const AuthDictionary = {
  login: () => "/login/loginuser",
  updateUserDetails: () => "/user/update_user",
  changePassword: () => "/user/update_password",
  resetPassword: () => "/login/loginuser/reset_pass",
  forgotPassword: () => "login/loginuser/forget_pass",
};

export default AuthDictionary;
